import apiService from "service/api";

export const getInventory = async (hfId: number) => {
  let url = `/vaccine/${hfId}/inventory/`;
  console.log(url);

  const method = "get";
  return apiService(url, method, null, true, {});
};

export const createInventory = async (
  hfId: number,
  formData: Record<string, any>
) => {
  const url = `/vaccine/${hfId}/inventory/`;

  return apiService(url, "POST", formData, true);
};

export const getInventoryVaccines = (hfId: number) => {
  const url = `/vaccine/${hfId}/inventory/categories/`;

  return apiService(url, "GET", null, true);
};
